// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2Tbhe","buttons":"SendReceipts_buttons__24L6C","email":"SendReceipts_email__3eRQx","bookApptTitle":"SendReceipts_bookApptTitle__2CNmW"};